import styled from "styled-components";

export const CloseBtnStyled = styled.button`
  padding: 6px;
  border-radius: 12px;
  -webkit-backdrop-filter: blur(30px);
  backdrop-filter: blur(30px);
  height: 36px;
  box-shadow: 0 1px 3px 0 rgba(53, 58, 80, 0.1);
  width: 36px;
  background-color: #ffffff;
`;
